import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCrewDamageType } from './multi/voyageMessageCrewHurt'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

const _offsets4 = [
  [0, -1],
  [1, 0],
  [0, 1],
  [-1, 0],
]

export interface IVoyageCrewFire {
  fireTimer: number
}

export function create() {
  let d: IVoyageCrewFire = {
    fireTimer: 0,
  }
  return d
}

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.fireState
  assert.notNil(d)

  if (obj.isDead) {
    return
  }
  if (obj.isDying) {
    voyageCrew.kill(obj)
    return
  }

  let status = voyageGameStatus.get()
  status.hasFire.willBeActive = true
  status.fireCount++

  d.fireTimer += ds
  const fireTime = 0.5

  if (d.fireTimer > fireTime) {
    let addHitpoints = 2

    d.fireTimer -= fireTime
    obj.image.flipX = !obj.image.flipX

    if (!voyageWebsockets.getIsHost()) {
      return
    }

    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      if (tHere.breach) {
        addHitpoints -= 20
      }
    }

    if (status.oxygen < 10) {
      addHitpoints -= 2
    }
    if (status.oxygen < 5) {
      addHitpoints -= 2
    }

    if (obj.hitpoints + addHitpoints > 40) {
      addHitpoints -= 20

      let dir = rando.sample(_offsets4)
      let tNew = voyageTilemap.getSafeOffset(obj, dir[0], dir[1])
      if (tNew && tNew.tile2.canWalk) {
        if (tNew.fire === null) {
          voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
            crewId: createId(),
            i: tNew.i,
            j: tNew.j,
            type: EVoyageCrewType.Fire,
            team: -1,
            method: EVoyageCrewCreateMethod.Normal,
            energy: 0,
          })

          // let f = voyageCrew.create(EVoyageCrewType.Fire, -1)
          // voyageCrew.moveToIJ(f, tNew)
          // t.fire = f
        }
      }
    }

    if (addHitpoints) {
      voyageCrew.hurt(obj, -addHitpoints, EVoyageCrewDamageType.Null, 0)
    }
  }
}

// export function hurt(obj: IVoyageCrew, amount: number, byCrew: IVoyageCrew) {
//   if (voyageWebsockets.getIsHost()) {
//     obj.hitpoints -= amount
//     voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
//       crewId: obj.id,
//       newHitpoints: obj.hitpoints,
//       type: EVoyageCrewDamageType.FireExtinguisher,
//       byCrewId: ,
//     })
//   }
// }
